// Copyright © 2025 Neosocios - Seguimiento De Conversiones

document.addEventListener("DOMContentLoaded", function () {
  // Verificar si tracking_updated está en false o no existe en sessionStorage
  const trackingUpdated = sessionStorage.getItem("tracking_updated");

  if (trackingUpdated !== "true") {
    // Agregar delay de 2 segundos para garantizar que otros procesos del tema se ejecuten primero
    setTimeout(function () {
      
      // --- FUNCIONES DE UTILIDAD ---
      
      // Función para obtener el valor de un parámetro URL
      function getURLParameter(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name) || "";
      }

      // Función para obtener el valor de una cookie
      function getCookie(name) {
        const match = document.cookie.match(
          new RegExp("(^| )" + name + "=([^;]+)")
        );
        return match ? match[2] : null;
      }

      // Función para crear/guardar una cookie (NUEVA)
      function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = name + "=" + value + ";expires=" + date.toUTCString() + ";path=/";
      }

      // --- FUNCIONES GENERADORAS DE FALLBACK (NUEVAS) ---

      // Función para generar un Client ID válido para GA4
      function generateFallbackClientId() {
        const randomInt = Math.floor(Math.random() * 2147483647);
        const timestamp = Math.floor(Date.now() / 1000);
        return randomInt + "." + timestamp;
      }

      // Función para generar un Session ID válido (Timestamp en segundos)
      function generateFallbackSessionId() {
        return Math.floor(Date.now() / 1000).toString();
      }

      // --- LÓGICA DE PERSISTENCIA EN LOCALSTORAGE ---
      const utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
      let persistedUTMs = JSON.parse(localStorage.getItem("neo_utms")) || {};

      // Si detectamos UTMs en la URL, los guardamos/actualizamos
      let foundInUrl = false;
      utmKeys.forEach(function(key) {
        let val = getURLParameter(key);
        if (val) {
          persistedUTMs[key] = val;
          foundInUrl = true;
        }
      });

      if (foundInUrl) {
        localStorage.setItem("neo_utms", JSON.stringify(persistedUTMs));
      }

      // --- FUNCIONES DE EXTRACCIÓN DE GA4 ---

      // Función para obtener el último fragmento después del punto de _gcl_aw
      function getGclidFromCookie() {
        const gclAw = getCookie("_gcl_aw");
        if (gclAw) {
          const parts = gclAw.split(".");
          return parts[parts.length - 1] || "";
        }
        return "";
      }

      // Función para obtener el client_id limpio de la cookie _ga original
      function getClientIdFromCookie() {
        const gaCookie = getCookie("_ga");
        if (gaCookie) {
          const parts = gaCookie.split(".");
          if (parts.length >= 4) {
            return parts.slice(2).join(".");
          }
        }
        return "";
      }

      // Función para obtener el session_id limpio de la cookie _ga_H48M065CYK original
      function getSessionIdFromCookie() {
        const gaSessionCookie = getCookie("_ga_H48M065CYK");
        if (gaSessionCookie) {
          const parts = gaSessionCookie.split(".");
          if (parts.length >= 3) {
            let sessionRaw = parts[2];
            let sessionTimestamp = sessionRaw.split("$")[0];
            if (sessionTimestamp.startsWith("s")) {
              return sessionTimestamp.substring(1);
            }
            return sessionTimestamp;
          }
        }
        return "";
      }

      // --- LÓGICA DE RESPALDO (SAFE EXTRACTORS) ---

      // Función segura para obtener Client ID (Intenta GA4, luego Neo, luego Crea)
      function getClientIdSafe() {
        let clientId = getClientIdFromCookie();
        if (!clientId) {
          clientId = getCookie("_neo_client_id");
          if (!clientId) {
            clientId = generateFallbackClientId();
            setCookie("_neo_client_id", clientId, 365); // Guarda por 1 año
          }
        }
        return clientId;
      }

      // Función segura para obtener Session ID (Intenta GA4, luego Neo, luego Crea)
      function getSessionIdSafe() {
        let sessionId = getSessionIdFromCookie();
        if (!sessionId) {
          sessionId = getCookie("_neo_session_id");
          if (!sessionId) {
            sessionId = generateFallbackSessionId();
            setCookie("_neo_session_id", sessionId, 1); // Guarda por 1 día
          }
        }
        return sessionId;
      }

      // --- RECOPILACIÓN Y ENVÍO ---

      // Recopilar todos los valores (AHORA USANDO LAS FUNCIONES SEGURAS)
      const trackingData = {
        source: getURLParameter("utm_source") || persistedUTMs["utm_source"] || "",
        medium: getURLParameter("utm_medium") || persistedUTMs["utm_medium"] || "",
        campaign: getURLParameter("utm_campaign") || persistedUTMs["utm_campaign"] || "",
        term: getURLParameter("utm_term") || persistedUTMs["utm_term"] || "",
        content: getURLParameter("utm_content") || persistedUTMs["utm_content"] || "",
        fbp: getCookie("_fbp"),
        fbc: getCookie("_fbc"),
        ttp: getCookie("_ttp"),
        ttclid: getCookie("ttclid"),
        gclid: getGclidFromCookie(),
        ga_client_id: getClientIdSafe(),   // <-- Modificado
        ga_session_id: getSessionIdSafe(), // <-- Modificado
        kla_id: getCookie("__kla_id"),
        kx: getURLParameter("_kx") || getCookie("_kx")
      };

      // Construir el objeto attributes solo con valores existentes
      const attributes = {};

      // Agregar atributo de verificación de Neosocios SIEMPRE
      attributes.Neosocios = "true";

      // Agregar demás atributos solo si existen
      if (trackingData.source) attributes.Source = trackingData.source;
      if (trackingData.medium) attributes.Medium = trackingData.medium;
      if (trackingData.campaign) attributes.Campaign = trackingData.campaign;
      if (trackingData.term) attributes.Term = trackingData.term;
      if (trackingData.content) attributes.Content = trackingData.content;
      if (trackingData.fbp) attributes.fbp = trackingData.fbp;
      if (trackingData.fbc) attributes.fbc = trackingData.fbc;
      if (trackingData.ttp) attributes.ttp = trackingData.ttp;
      if (trackingData.ttclid) attributes.ttclid = trackingData.ttclid;
      if (trackingData.gclid) attributes.gclid = trackingData.gclid;
      if (trackingData.ga_client_id) attributes.ga_client_id = trackingData.ga_client_id;
      if (trackingData.ga_session_id) attributes.ga_session_id = trackingData.ga_session_id;
      if (trackingData.kla_id) attributes.kla_id = trackingData.kla_id;
      if (trackingData.kx) attributes.kx = trackingData.kx;

      // Actualizar los note_attributes del carrito usando la API de Shopify
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ attributes }),
      })
        .then((response) => {
          if (response.ok) {
            console.log("Neosocios: Cart attributes updated successfully");
            sessionStorage.setItem("tracking_updated", "true");
          }
          return response.json();
        })
        .then((data) => {
          console.log("Neosocios: Updated cart ", data);
        })
        .catch((error) => {
          console.error("Neosocios: Error updating cart attributes:", error);
        });
    }, 2000); // Delay de 2 segundos
  }
});